import { type SparksProactiveQuestion } from './types';

export const QUESTION_POOL: readonly SparksProactiveQuestion[] = [
    // Core Period Comparison (3)
    {
        id: 'period_changed',
        intent: 'core_period_comparison',
        translationKey: 'question_period_changed'
    },
    {
        id: 'metrics_changed',
        intent: 'core_period_comparison',
        translationKey: 'question_metrics_changed'
    },
    {
        id: 'performance_trend',
        intent: 'core_period_comparison',
        translationKey: 'question_performance_trend'
    },
    // Focus & Prioritization (3)
    {
        id: 'metrics_focus',
        intent: 'focus_prioritization',
        translationKey: 'question_metrics_focus'
    },
    { id: 'standout', intent: 'focus_prioritization', translationKey: 'question_standout' },
    {
        id: 'biggest_impact',
        intent: 'focus_prioritization',
        translationKey: 'question_biggest_impact'
    },
    // Stability & Consistency (2)
    { id: 'stability', intent: 'stability_consistency', translationKey: 'question_stability' },
    {
        id: 'posting_frequency',
        intent: 'stability_consistency',
        translationKey: 'question_posting_frequency'
    },
    // Audience & Growth (2)
    {
        id: 'audience_growth',
        intent: 'audience_growth',
        translationKey: 'question_audience_growth'
    },
    { id: 'interactions', intent: 'audience_growth', translationKey: 'question_interactions' }
];
